module.exports = __webpack_public_path__ + "img/_notifications_setting.3e85d151.svg";